import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

const selectGamificationState = (state: AppStateType) => state.gamification;

export const selectIsGamificationLoading = createSelector([selectGamificationState], state => state.isLoading);

export const selectGamificationProducts = createSelector([selectGamificationState], state => state.products);

export const selectGameDetails = createSelector([selectGamificationState], state => state.gameDetails);

export const selectGameEnrollments = createSelector([selectGamificationState], state => state.gameEnrollments);

export const selectGamesProgress = createSelector([selectGamificationState], state => state.gamesProgress);

export const selectCurrentGameProgress = createSelector(
  [selectGamesProgress, selectGameDetails],
  (gamesProgress, gameDetails) => {
    if (!gameDetails) return null;
    return gamesProgress[gameDetails.slug] ?? { levels: {}, products: [] };
  },
);
